(() => {
  'use strict';
  const content = document.querySelector('.page__content');
  if (!content || content.dataset.monolithLegal) return;
  const children = [...content.children];
  const heading = node => {
    if (node.tagName === 'H2') return true;
    if (node.tagName !== 'P') return false;
    const strong = node.querySelector('strong,b');
    return !!strong && strong.textContent.trim() === node.textContent.trim() && /:\s*$/.test(node.textContent) && node.textContent.length < 150;
  };
  if (children.filter(heading).length < 2) return;
  const normalize = text => text.replace(/\s/g, '');
  const original = normalize(content.textContent);
  const links = element => [...element.querySelectorAll('a')].map(a => [a.textContent, a.getAttribute('href')]);
  const originalLinks = links(content);
  const root = document.createElement('div');
  root.className = 'mba';
  const intro = document.createElement('div');
  intro.className = 'mba__intro mba__legal-intro';
  const layout = document.createElement('div');
  layout.className = 'mba__layout';
  const nav = document.createElement('nav');
  nav.className = 'mba__nav';
  nav.setAttribute('aria-label', document.querySelector('h1')?.textContent.trim() || '');
  const navList = document.createElement('ul');
  nav.append(navList);
  const sections = document.createElement('div');
  sections.className = 'mba__sections';
  let target = intro;
  let index = 0;
  children.forEach(node => {
    if (!node.textContent.trim() && !node.querySelector('img,iframe,video,input')) return;
    if (heading(node)) {
      const section = document.createElement('section');
      section.className = 'mba__section';
      const h2 = document.createElement('h2');
      h2.id = `monolith-legal-topic-${++index}`;
      h2.textContent = node.textContent.trim();
      section.setAttribute('aria-labelledby', h2.id);
      section.append(h2);
      sections.append(section);
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = `#${h2.id}`;
      link.textContent = h2.textContent;
      item.append(link);
      navList.append(item);
      target = section;
    } else target.append(node.cloneNode(true));
  });
  if (normalize(intro.textContent + sections.textContent) !== original) return;
  if (JSON.stringify([...links(intro), ...links(sections)]) !== JSON.stringify(originalLinks)) return;
  layout.append(nav, sections);
  if (intro.textContent.trim()) root.append(intro);
  root.append(layout);
  content.replaceChildren(root);
  content.dataset.monolithLegal = 'true';
  document.body.classList.add('monolith-accessibility-page', 'monolith-privacy-page', 'monolith-legal-page');
})();
